import $ from 'jquery';
import { t } from 'react-switch-lang';

export function setScreenReaderAlert(
  msg,
  appendTo = document.body,
  role = 'alert'
) {
  const alert = document.createElement('SPAN');
  alert.className = 'visually-hidden';
  alert.setAttribute('role', role);
  alert.textContent = msg;
  appendTo.appendChild(alert);

  if (process.env.REACT_APP_ENV !== 'prod') {
    // eslint-disable-next-line
    console.log(`Role with ${role} saying ${msg}`);
  }
}

export function moveFocusTo(id) {
  const el = document.getElementById(id);
  el.setAttribute('tabIndex', -1);
  el.focus();
}

export function moveFocusToClass(cls) {
  $(`.${cls}`).focus();
}

export function invalidFormAlert(invalid, errors, singleError = false) {
  let alertString = '';
  const errorFields = Object.keys(errors || {}).filter((name) => name !== '_');

  if (invalid && errors && errorFields.length > 0) {
    if (singleError) {
      setScreenReaderAlert(Object.values(errors)[0]);
      return;
    }

    const focusElem = document.getElementsByName(errorFields[0])[0];
    focusElem?.focus();
    focusElem?.scrollIntoView({ behavior: 'smooth', block: 'center' });

    errorFields.forEach((item) => {
      if (!singleError && errors[item] !== true) {
        const fieldLabel = document.getElementById(`${item}Lbl`) ||
          document.getElementById(`${item}Label`);
        const labelText = fieldLabel?.firstChild?.textContent;
        if (labelText) {
          alertString += `${labelText}, `;
        }
      }
    });

    if (alertString.length > 0) {
      setScreenReaderAlert(t('ScreenReaderAlert_InvalidFormField').replace('xField', alertString));
    }
  }
}
